import { authHeaders, handleUnauthorized } from './http';
const BASE = '/api/extensibility';

async function extRequest<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${BASE}${path}`, {
    headers: { 'Content-Type': 'application/json', ...authHeaders(), ...(init?.headers || {}) },
    ...init,
  });
  handleUnauthorized(res);
  if (!res.ok) throw new Error(await res.text() || res.statusText);
  return res.json();
}

export const extApi = {
  meta: () => extRequest('/meta'),
  variables: (userOnly = false) => extRequest(`/variables?user_defined_only=${userOnly}`),
  createVariable: (body: unknown) => extRequest('/variables', { method: 'POST', body: JSON.stringify(body) }),
  getVariable: (id: string) => extRequest(`/variables/${id}`),
  createLinkage: (body: unknown) => extRequest('/linkages', { method: 'POST', body: JSON.stringify(body) }),
  validateFormula: (formula: string) => extRequest('/formulas/validate', { method: 'POST', body: JSON.stringify({ formula }) }),
  dependencyGraph: () => extRequest('/dependency-graph'),
  graphFocus: (nodeId: string) => extRequest(`/dependency-graph/${encodeURIComponent(nodeId)}`),
  modelLibrary: () => extRequest('/model-library'),
  subModels: () => extRequest('/sub-models'),
  createSubModel: (body: unknown) => extRequest('/sub-models', { method: 'POST', body: JSON.stringify(body) }),
  toggleSubModel: (id: string, active: boolean) => extRequest(`/sub-models/${id}/active?active=${active}`, { method: 'PATCH' }),
  actions: () => extRequest('/actions'),
  createAction: (body: unknown) => extRequest('/actions', { method: 'POST', body: JSON.stringify(body) }),
  verification: () => extRequest('/verification'),
  trends: (variableId: string) => extRequest(`/trends/${encodeURIComponent(variableId)}`),
  gapDecomposition: () => extRequest('/gap-decomposition'),
  projectionControls: () => extRequest('/projection-controls'),
  toggleProjection: (variable_id: string, enabled: boolean) =>
    extRequest('/projection-controls/toggle', { method: 'POST', body: JSON.stringify({ variable_id, enabled }) }),
  applyPreset: (preset: string) =>
    extRequest('/projection-controls/preset', { method: 'POST', body: JSON.stringify({ preset }) }),
  resetProjection: () => extRequest('/projection-controls/reset', { method: 'POST' }),
};
